<template>
  <div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="订单信息" name="1">
        一、订单状态查询 <br/><br/>
        您可通过访问”海尔智家APP|海尔智家微信公众号|海尔积分商城网页版“登录积分商城，查询订单信息，具体方式为：
点击登录并输入手机号和服务密码，登陆后进入“我的-积分商城-全部订单”，即可查询已兑换订单信息及订单配送情况（配送物流动态仅支持查询已发货3个月内订单）。 <br/><br/>
        二、特别说明<br/><br/>
        积分商城为会员福利礼品兑换类网站，由于平台特殊性，已经支付成功的订单，不支持无理由订单取消，不予退货（用户自行拒收导致商品退回，平台保留扣除订单积分用于抵扣物流费用权力）；同时针对已下单未支付订单，24小时后订单将自动关闭。 注：因商品发货方自身原因而违背”商品有效发货/订单成交信息“等规范申请订单取消，须商品发货方自行沟通用户协商处理解决。
      </van-collapse-item>
      <van-collapse-item title="配送范围" name="2">
        <p>
          一、配送范围<br/><br/>
          海尔智家积分商城配送范围仅限中国大陆地区（不包含港、澳、台）。国外及港、澳、台会员兑换商品收件请填写中国大陆地区地址。海尔积分商城保留更换调整个别商品可兑换区域的权利，请以商品实际可下单区域为准，给您带来的不便敬请谅解。<br/><br/>
          二、配送时限<br/><br/>
          自用户兑换成功且接收到下单成功通知短信的次日开始计时，积分商城于3个工作日内安排发货（青海、新疆、西藏等偏远地区除外），因以下原因导致发货及配送延期，积分商城不支持催发货，具体请以实际订单物流更新为准，如给您带来不便，敬请谅解：<br/>
1.因下单预留收货信息不详细或错误导致派送受阻或退回；<br/>
2.受各区域实际物流管控影响导致发货或配送受限；<br/>
3.因个别商品特殊属性，存在发货延期，详情可参考商品详情页信息或下单注意事项。<br/><br/>
          三、配送地址须知<br/><br/>
          (1)请务必在订单中留下您正确有效的收货信息，以便您能够及时地收到商品。如因用户信息变更或提供信息错误而导致商品配送失败的，用户应承担相应配送服务费用并提供正确信息后重新配送。<br/>
          (2)由于某些特殊及不可控原因，有可能造成配送延迟，给您带来的不便敬请谅解。
        </p>
      </van-collapse-item>
       <van-collapse-item title="商品验货与签收" name="3">
        收货须知<br/><br/>
        (1)请您务必在收到商品时进行验货。如您验收时发现商品包装破损、商品短缺或错误、商品存在表面质量问题等，请您现场向配送人员指出后拒收整个包裹，我们将安排为您重新发货。<br/>
        (2)建议您本人签收商品，如您无法亲自签收，请在物流配送商与您联系时告知配送人员指定代签收人姓名及联系方式。<br/>
        (3)您或您委托的收货人确认签字后，代表您已对收到商品的名称、数量等信息确认无误，且无(1)条中所述现象存在，海尔积分商城有权不接受以此为由的退换货。<br/>
        （4）积分商城实物订单支持发货后3个月内查询物流动态，因物流逾期将无法获取动态，积分商城默认订单有效签收，给您带来的不便敬请谅解。
      </van-collapse-item> 
      <van-collapse-item title="商品发票说明" name="4">
       积分商城是会员福利兑换网站，由于平台特殊性，统一积分兑换的商品是没有发票的，请您谅解！
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { sysNotice } from "@/api/api";
export default {
  data() {
    return {
      list: [],
      activeNames: [],
    };
  },
  methods: {
    
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.text {
  padding-top: 50px;
}
/deep/.blue {
  color: #2283e2 !important;
}
.contai {
  background: #fff;
  // border: 1px solid #2283e2;
  padding: 20px;
}

.header {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #2283e2;
}

.paging {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.title {
  font-size: 25px;
  cursor: pointer;
}

.title:hover {
  color: #2283e2;
}
</style>
